module.exports = __webpack_public_path__ + "img/ff4ba1e.jpg";